import classNames from "classnames";
import React, { useEffect, useState } from "react";

import { KEY_CODES } from "../../utils/helpers/keyCodes";
import { sleep } from "../../utils/helpers/sleep";
import { useEventListener, useSelector } from "../../utils/hooks";

import "./Overlay.scss";

interface OverlayPropsI {
	onOverlayHide: () => void;
}

export const Overlay = ({ onOverlayHide }: OverlayPropsI) => {
	const [isOpacityHidden, setIsOpacityHidden] = useState(true);
	const [isDisplayed, setIsDisplayed] = useState(false);

	const isVisible = useSelector((state) => state.popup.products.isVisible);

	const onOverlayClick = (event: React.MouseEvent) => {
		if (event.target === event.currentTarget) {
			onOverlayHide();
		}
	};

	const onEscapeKeyHandler = (event: React.KeyboardEvent) => {
		if (isVisible && isDisplayed && event.key === KEY_CODES.ESCAPE) {
			onOverlayHide();
		}
	};

	const showOverlay = async () => {
		setIsOpacityHidden(false);
		await sleep(100);
		setIsDisplayed(true);
	};

	const hideOverlay = async () => {
		onOverlayHide();
		setIsOpacityHidden(true);
		await sleep(300);
		setIsDisplayed(false);
	};

	useEffect(() => {
		if (isVisible) {
			showOverlay();
		} else if (isDisplayed) {
			hideOverlay();
		}
	}, [isVisible, isDisplayed]);

	useEventListener({
		type: "keydown",
		handler: onEscapeKeyHandler,
	});

	return (
		<div
			tabIndex={0}
			onClick={onOverlayClick}
			className={classNames({
				"addtocart-overlay": true,
				caas: true,
				show: !isOpacityHidden,
			})}
			style={{
				display: isDisplayed ? "block" : "none",
			}}
		></div>
	);
};
